import apiRequestService from '@/commonProject/service/apiRequestService';

export default class ContactRepository {
    /**
     * 連絡一覧API
     * @param {Object} requestBody
     * @returns result
     */
    async postContactListActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/conlst', requestBody, idToken);
        return result;
    }
    /**
     * 連絡添付ファイルダウンロードAPI
     * @param {Object} requestBody
     * @returns result
     */
    async postContactFileDownloadActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/confildld', requestBody, idToken);
        return result;
    }
     /**
     * 連絡メッセージ登録API
     * @param {Object} requestBody
     * @returns result
     */
    async postContactDetailActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/condtl', requestBody, idToken);
        return result;
    }
    /**
     * 連絡メッセージ添付ファイルアップロードAPI
     * @param {Object} requestBody
     * @returns result
     */
    async postContactFileUploadActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/confiluld', requestBody, idToken);
        return result;
    }
    /**
     * 連絡既読登録API
     * @param {Object} requestBody
     * @returns result
     */
    async postContactReadActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/conred', requestBody, idToken);
        return result;
    }
}
